import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineLite} from "gsap";
import {DragonTribeSoundConfig} from "../DragonTribeSoundConfig";
import {DragonTribeGameConfig} from "../DragonTribeGameConfig";

export class DTSoundPlayer {
    private _currentMusic:string;

    constructor() {}

    public switchToFreespinMusic() {
        if(this._currentMusic == DragonTribeSoundConfig.instance.FREE_SPIN_AMBIANCE) {
            return;
        }
        SlotGame.sound.playAmbience(DragonTribeSoundConfig.instance.FREE_SPIN_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 0);
        this._currentMusic = DragonTribeSoundConfig.instance.FREE_SPIN_AMBIANCE;
    }

    public switchToMainMusic(fadeIn:boolean = false) {
        if(this._currentMusic == DragonTribeSoundConfig.instance.MAIN_GAME_AMBIANCE) {
            return;
        }
        const tl:TimelineLite = new TimelineLite({
            onComplete : () => {
                if(fadeIn) {
                    SlotGame.sound.fadeAmbience(1, 2000);
                }
            }
        });
        tl.add(() => SlotGame.sound.playAmbience(DragonTribeSoundConfig.instance.MAIN_GAME_AMBIANCE));
        this._currentMusic = DragonTribeSoundConfig.instance.MAIN_GAME_AMBIANCE;
    }

    public playNormalWinSound(winRatioConfig:IWinRatioConfig): void {
        // #315
        if (DragonTribeGameConfig.instance.WIN_BELOW_STAKE) {
            return;
        }

        let soundName:string;
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                soundName = DragonTribeSoundConfig.TINY_WIN;
                break;
            case WinRatioType.SMALL:
                soundName = DragonTribeSoundConfig.SMALL_WIN;
                break;
            case WinRatioType.MEDIUM:
                soundName = DragonTribeSoundConfig.MEDIUM_WIN;
                break;
            case WinRatioType.LARGE:
                soundName = DragonTribeSoundConfig.LARGE_WIN;
                break;
            default:
                soundName = "";
                break;
        }
        SlotGame.sound.playEffect(soundName);
    }
}